import { createAsyncThunk } from '@reduxjs/toolkit'
import ChangeLog from './change-log-model'
import {
  delete_changeLog,
  load_changeLogs,
  store_changeLog,
} from './changeLog-service'

export const LoadChangeLogsAsync = createAsyncThunk<any, any>(
  'composer/load/changeLog',
  async (params: { uid: string }) => {
    return await load_changeLogs(params)
  },
)

export const CreateChangeLogAsync = createAsyncThunk<any, any>(
  'composer/create/changeLog',
  async (params: ChangeLog) => {
    return await store_changeLog(params)
  },
)

export const DeleteChangeLogAsync = createAsyncThunk<any, any>(
  'composer/delete/changeLog',
  async (params) => {
    return await delete_changeLog(params)
  },
)
